module.exports = __webpack_public_path__ + "static/img/bifc-Integrated-management.8f54902.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/bifc-Integrated-management.jpg
// module id = LMHq
// module chunks = 0